import './styles/Footer.css';

const Footer = () => (
  <footer className="footer-text">
    &copy; 2023 CryptoGate - Made with
    <span className="heart">❤</span>
    by
    <span className="dev-name"> Prosper Kessie.</span>
  </footer>
);

export default Footer;
